export default __webpack_public_path__ + "static/media/view.52a006e3.svg";